module.exports = __webpack_public_path__ + "static/media/map-background.1755da3e.png";